import { useEffect, useState } from "react";
import { useGestionConocimientos } from "../../../hooks/gestionConocimientos/useGestionConocimientos";
import { ContenedorParametros } from "../../components/utils/ContenedorParametros"
import { ContenedorTabla } from "../../components/utils/ContenedorTabla"
import { Tooltip } from "../../components/utils/Tooltip";
import { BotonNuevo } from "../../components/buttons/BotonNuevo";
import { BotonProcesar } from "../../components/buttons/BotonProcesar";
import { useModal } from "../../../hooks/useModal";
import { Modal } from "../../components/modal/Modal";
import { Box, setRef, Tab, Tabs } from "@mui/material";
import { DatePickerABX } from "../../components/pickers/DatePicker";
import { SwitchToggle } from "../../components/SwitchToggle";
import { formatDate, notify } from "../../../utils/utils";

export const InventarioDominios = ()  => {
    const [ valorEstado, setValorEstado ] = useState(0);
    const [ isOpenModalDominio, openModalDominio, closeModalDominio ] = useModal(null);
    const [ isOpenModalEliminarDominio, openModalEliminarDominio, closeModalEliminarDominio ] = useModal(null);
    const datosEliminarDefault = {
        codGestionConocimiento: 0,
        motivoEliminacion: ""
    }
    const [ datosEliminar, setDatosEliminar ] = useState(datosEliminarDefault)
    const editarValorEliminacion = (key,value) =>{
        setDatosEliminar(leccion => {
            return {
                ...leccion,
                [key]: value
            }
        })
    }
    const idTabla = 'TablaDominio'
    const classNameInput = "py-1 px-2 caret-white containerScroll text-white  rounded  bg-zinc-900 text-l focus:outline-none focus:ring-1 focus:ring-blue-500 disabled:opacity-70 disabled:cursor-not-allowed";
    const classNameSelect = "py-1 px-2 containerScroll text-white  rounded  bg-zinc-900 text-l focus:outline-none focus:ring-1 focus:ring-blue-500";

    const {
        listarEstados,
        listaEstadoConocimiento,
        listarProveedorDominio,
        listaProveedorDominio,
        listarProveedorSSL,
        listaProveedorSSL,
        listarComboServidores,
        listaServidores,


        listarDominios,
        dominios,
        listarDetalleDominio,
        detalleDominio,
        editarValorDominio,
        guadarEditarDominio,
        eliminarDominio,
    } = useGestionConocimientos()

    useEffect(() => {
        (async ()=> {
            await listarEstados();
            await listarProveedorSSL();
            await listarComboServidores();
            await listarDominios(valorEstado);
            await listarProveedorDominio();

        })()
    },[])


    const registrarDominio = async () => {
        
        const camposAValidar = ["nomDominio", "codProveedorDominio",
        "codGestionInfraestructuraServidor", "fechaCompra", "fechaRenovacion", "codProveedorSSL",
        "expiracionSSL", "certificadoSSL", "descripcionDominio"];

        const validarInciencia = camposAValidar.some(campo => detalleDominio[campo] === "" || detalleDominio[campo] === null || detalleDominio[campo] === 0 || detalleDominio[campo] === undefined);
        if(validarInciencia){
            notify("Falta completar datos del formulario", "warning");
            return
        }
        const isValid = await guadarEditarDominio();
        if(isValid){
            await listarDominios(valorEstado)
            closeModalDominio();
        }
    }

    const labelEstado = (codEstado, nomEstado) => {
        let color = ' bg-gray-600 ';
        switch(codEstado){
            case 1: color = ' bg-green-600 ';
            break;
            case 10: color = ' bg-red-600 ';
            break;
            default: color = ' bg-yellow-600 '
        }
        return <span className={`inline-block w-[60px] px-2 text-center ${color}  rounded `}>{nomEstado}</span>
    }

    const compararFechas = (fecha1Str, fecha2Str) => {
        // Convertir las cadenas de fecha a objetos Date
        const [dia1, mes1, año1] = (fecha1Str? fecha1Str : formatDate(new Date())).split('/').map(Number);
        const [dia2, mes2, año2] = fecha2Str.split('/').map(Number);
        
        const fecha1 = new Date(año1, mes1 - 1, dia1);
        const fecha2 = new Date(año2, mes2 - 1, dia2);
        
        // Comparar las fechas
        return fecha1 >= fecha2;
    }
      
      // Ejemplo de uso con Tailwind
    const aplicarEstiloFecha = (fecha1, fecha2) => {
        const esMayorOIgual = compararFechas(fecha1, fecha2);    
        return esMayorOIgual ? 'text-green-600' : 'text-red-600';
    }

    const eliminar = async () => {
        const camposAValidar = ["motivoEliminacion"];
        const validarEliminacion = camposAValidar.some(campo => datosEliminar[campo] === "" || datosEliminar[campo] === null || datosEliminar[campo] === 0 || datosEliminar[campo] === undefined);
        if(validarEliminacion){
            notify("Falta completar datos del formulario", "warning");
            return
        }
        const isValid = await eliminarDominio(detalleDominio.codGestionInfraestructuraDominio, datosEliminar.motivoEliminacion);
        if(isValid){
            await listaServidores();
            closeModalEliminarDominio();
        }
    }


    return(
        <>
            <ContenedorParametros
                titulo='Inventario de dominios'
                tablaId={idTabla}
            >
                <i className="fa fa-filter" data-tip="iconoEstado" data-for="iconoEstado"></i>
                <Tooltip id={"iconoEstado"}>Estados</Tooltip>
                <select
                    id="selectEstadoDominio"
                    className={classNameSelect}
                    value={valorEstado}
                    onChange={(e) => setValorEstado(Number(e.target.value))}
                >
                    <option key={'opcionTodos_Estado'} value={0}>--Todos--</option>
                    {
                        listaEstadoConocimiento.map(e => (
                            <option key={e.codEstado} value={e.codEstado}>{e.nomEstado}</option>
                        ))
                    }
                </select>
                <BotonNuevo
                    onClick={async () => {
                        listarDetalleDominio()
                        openModalDominio()
                    }}
                />
                <BotonProcesar onClick={()=> listarDominios(valorEstado)}/>
            </ContenedorParametros>
            <ContenedorTabla>
                <table id={idTabla} className="table">
                    <thead>
                        <tr>
                            <th>N</th>
                            <th>CÓDIGO</th>
                            <th>NOMBRE</th>
                            <th>FECHA COMPRA</th>
                            <th>FECHA RENOVACIÓN</th>
                            <th>CERTIFICADO SSL</th>
                            <th>VENCIMIENTO SSL</th>
                            <th>PROVEEDOR SSL</th>
                            <th>ESTADO SSL</th>
                            <th>PROVEEDOR</th>
                            <th>SERVIDOR</th>
                            <th>ESTADO</th>
                            {
                                valorEstado === 0 ? 
                                <th></th>
                                : 
                                <></>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {
                            dominios.length > 0 ? 
                                dominios.map((dom, i) => (
                                  <tr>
                                    <td className="text-center">{i + 1}</td>
                                    <td className="text-center">{dom.codigoDominio || ''}</td>
                                    <td className="text-center">{dom.nomDominio || ''}</td>
                                    <td className="text-center">{dom.fechaCompra || ''}</td>
                                    <td className="text-center">{dom.fechaRenovacion || ''}</td>
                                    <td className="text-center">{dom.certificadoSSL || ''}</td>
                                    <td className="text-center">{dom.nomProveedorSSL || ''}</td>
                                    <td className="text-center max-w-[250px] overflow-hidden text-ellipsis whitespace-nowrap" contenteditable="true">{dom.expiracionSSL || ''}</td>
                                    <td className="text-center">
                                        {(dom.nomEstadoSSL || '') + '  '}  
                                        <i className={`fa fa-circle ${aplicarEstiloFecha(dom.expiracionSSL , formatDate(new Date()))}`}></i>
                                    </td>
                                    <td className="text-center">{dom.nomProveedorDominio || ''}</td>
                                    <td className="text-center">{dom.servidor || ''}</td>
                                    <td className="text-center">{labelEstado(dom.codEstado, dom.nomEstado)}</td>
                                    {
                                        valorEstado === 0 ?
                                            <td className="text-center">
                                                <i
                                                    className="fa fa-edit text-blue-600"
                                                    onClick={async () => {
                                                        await listarDetalleDominio(dom)
                                                        openModalDominio()
                                                    }}
                                                ></i>
                                            </td>
                                        :
                                            <></>
                                    }
                                  </tr>  
                                ))
                            :
                                <tr>
                                    <td colSpan={12} className="text-center">No hay información para mostrar...</td>
                                </tr>
                        }
                    </tbody>
                </table>
            </ContenedorTabla>

            <Modal
                isOpen={isOpenModalDominio}
                closeModal={closeModalDominio}
                action={()=> registrarDominio()}
                title={`${detalleDominio.codGestionInfraestructuraDominio === 0 ? "Nuevo registro de dominio" : `Editar [${detalleDominio.codigoDominio}] ` }`}
            >
                <fieldset className="border-zinc-600 border rounded-md w-[650px]">
                    <legend className="mx-2">Dominio</legend>
                    <section className=" grid grid-cols-[minmax(0,25fr)_minmax(0,25fr)_minmax(0,25fr)_minmax(0,25fr)] items-center gap-2 p-2">
                        <label htmlFor="nomDominio">Nombre</label>
                        <input
                            id="nomDominio"
                            value={detalleDominio.nomDominio}
                            onChange={(e) => editarValorDominio('nomDominio', e.target.value)}
                            className={classNameInput}
                        />
                        <label htmlFor="proveedor">Proveedor</label>
                        <select 
                            id="proveedor"
                            value={detalleDominio.codProveedorDominio}
                            onChange={(e) => editarValorDominio('codProveedorDominio', Number(e.target.value))}
                            className={classNameInput}
                        >
                            <option key={'opcionTodosProveedor'} value={0}>-- Seleccione --</option>
                            {
                                listaProveedorDominio.length > 0  ?
                                    listaProveedorDominio.map(dom => (
                                        <option key={dom.codProveedorDominio} value={dom.codProveedorDominio}>{dom.nomProveedorDominio}</option>
                                    ))
                                :
                                    <></>
                            }
                        </select>
                        <label htmlFor="servidor">Servidor</label>
                        <select
                            id="servidor"
                            className={classNameInput}
                            onChange={(e) => editarValorDominio('codGestionInfraestructuraServidor', Number(e.target.value))}
                            value={detalleDominio.codGestionInfraestructuraServidor}
                        >
                            <option key={'servidorSeleccione'} value={0}>--Seleccione--</option>
                            {
                                listaServidores.length > 0 ?
                                    listaServidores.map(ser => (
                                        <option key={ser.codGestionInfraestructuraServidor} value={ser.codGestionInfraestructuraServidor}>{ser.nomServidor}</option>
                                    ))
                                : 
                                    <></>
                            }
                        </select>
                        <label>Fecha compra</label>
                        <DatePickerABX
                            date={detalleDominio.fechaCompra}
                            setDate={editarValorDominio}
                            classNameInput={'bg-zinc-900 w-[150px]'}
                            keyDate='fechaCompra'
                            ocultarIcono={true}
                        />
                        <label>Fecha renovación</label>
                        <DatePickerABX 
                            date={detalleDominio.fechaRenovacion}
                            setDate={editarValorDominio}
                            classNameInput={'bg-zinc-900 w-[150px]'}
                            keyDate='fechaRenovacion'
                            ocultarIcono={true}
                        />
                        <label htmlFor="proveedorSSL">Proveedor SSL</label>
                        <select 
                            id="proveedorSSL"
                            value={detalleDominio.codProveedorSSL}
                            onChange={(e) => editarValorDominio('codProveedorSSL', Number(e.target.value))}
                            className={classNameInput}
                        >
                            <option key={'optionTodosSSL'} value={0}>--Seleccione--</option>
                            {
                                listaProveedorSSL.length > 0 ? 
                                    listaProveedorSSL.map(prov => (
                                        <option key={prov.codProveedorSSL} value={prov.codProveedorSSL}>{prov.nomProveedorSSL}</option>
                                    ))
                                :
                                    <></>
                            }
                        </select>
                        <label htmlFor="vencimientoSSL">Vencimiento SSL</label>
                        <DatePickerABX
                            date={detalleDominio.expiracionSSL}
                            setDate={editarValorDominio}
                            classNameInput={'bg-zinc-900 w-[150px]'}
                            keyDate='expiracionSSL'
                            ocultarIcono={true}
                        />
                        <label htmlFor="certificadoSSL">Certificado SSL</label>
                        <div>
                            <SwitchToggle
                                keyEdit={"certificadoSSL"}
                                setEdit={editarValorDominio}
                                valor={detalleDominio.certificadoSSL}
                            />
                        </div>
                        <div className="col-span-4 grid grid-cols-[minmax(0,245fr)_minmax(0,755fr)] items-center gap-2">
                            <label htmlFor="descripcionDominio">Descripción</label>
                            <textarea
                                id="descripcionDominio"
                                placeholder="Ingrese su descripción..."
                                className={classNameInput + ' w-full h-[80px] resize-none'}
                                onChange={(e) => editarValorDominio('descripcionDominio', e.target.value)}
                                value={detalleDominio.descripcionDominio}
                            />
                        </div>
                    </section>
                </fieldset>
            </Modal>

            {/* MODAL PARA ELIMINAR DOMINIO */}
            <Modal
                isOpen={isOpenModalEliminarDominio}
                closeModal={closeModalEliminarDominio}
                action={() => eliminar()}
                title={`Eliminar dominio [${detalleDominio.codGestionInfraestructuraDominio}]`}
                textButtons={{confirm: 'Guardar', denied: 'Cancelar'}}
            >
                <div className='grid gap-2 py-3 w-[350px]'>
                    <strong className="">Motivo:</strong>
                    <textarea
                        className={`${classNameInput}
                        h-[80px] resize-none`}
                        placeholder="Escriba aquí el motivo de la eliminación de leccion y aprendizaje..."
                        onChange={(e) => editarValorEliminacion('motivoEliminacion', e.target.value)}
                    />
                </div>
            </Modal>
        </>
    )
}